module.exports = __webpack_public_path__ + "img/E-WEB-Goal-10.9e25cd48.svg";